import React, { Component } from 'react';

import { Switch, Route, Redirect, withRouter } from 'react-router-dom';

import Logout from '../containers/Logout/Logout';
// import Welcome from '../components/Welcome/Welcome';
import Layout from '../components/Dashboard/Layout';
import TaskSchedules from '../containers/TaskSchedule/TaskSchedules';
import ManageActivities from '../containers/ManageActivities/ManageActivities';
import UpdateEmployer from '../containers/Employer/Employer';
import EditEmployee from '../containers/Employee/Employee';
import CreateEmployee from '../containers/Employee/CreateEmployee';
import ImportEmployee from '../containers/Employee/ImportEmployee';
import Locations from '../containers/Locations/Locations';
import Devices from '../containers/Devices/Device';
import Employees from '../containers/Employees/Employees';
import Offices from '../containers/Offices/Offices';
import Schedules from '../containers/Schedules/Schedules';
// import CreateSchedule from '../containers/Schedules/CreateSchedule';
import TourGuideSchedule from '../containers/Schedules/TourGuideSchedule';
import Departments from '../containers/Departments/Departments';
import TimeClockReport from '../containers/Reports/TimeClockReport';
import PhotoReport from '../containers/Reports/PhotoReport';
import LocationReport from '../containers/Reports/LocationReport';
import AbsenceReport from '../containers/Reports/AbsenceReport';
import TimeClocks from '../containers/TimeClocks/TimeClocks';
import CreateTimeClock from '../containers/TimeClocks/CreateTimeClock';
import ApplyRestrictions from '../containers/ApplyRestrictions/ApplyRestrictions';
import NotFound from '../components/NotFound/NotFound';
import EmailConfirmation from '../components/EmailConfirmation/EmailConfirmation';
import PremiumPayment from '../components/PremiumPayment/view';
import CreateLocation from '../containers/Locations/CreateLocation';
import EditLocation from '../containers/Locations/EditLocation';
// import BI from '../containers/BI/BI';
import Holidays from '../containers/Holidays/Holidays';
import withToken from '../hoc/withToken';
import Allowance from '../containers/Allowance/Allowances';
import CreateAllowance from '../containers/Allowance/CreateAllowance';
// import ExtraHours from '../containers/ExtraHours/ExtraHours';
import BankOfHours from '../containers/BankOfHours/BankOfHours';
import TourGuideBI from '../containers/BI/TourGuideBI';
// import BI from '../containers/BI/BI';
import BI2 from '../containers/BI/newBI';
import Calendar from '../containers/Calendar/Calendar';
import Accompaniment from '../containers/Accompaniment/view';
import ManageEmployees from '../containers/ManageEmployees/ManageEmployees';
import ImportAfdReport from '../containers/Reports/ImportAfdReport';
import SetList from '../containers/SetList/SetList';
// import Gestor from '../containers/Gestor/Gestor';
import Users from '../containers/Users/Users';
import Dismissed from '../containers/Dismissed/Dismissed';
import Subscription from '../containers/Subscription/Subscription';
import NewSubscription from '../containers/Subscription/NewSubscription';
import ThermalCam from '../containers/ThermalCam';
import TimeListReport from '../containers/Reports/TimeListReport';
import EmployeeViewModel from '../components/EmployeeInformationRegistration/modelView/EmployeeViewModel';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      premium: null
    };
  }

  componentDidMount() {
    const privileges = JSON.parse(localStorage.getItem('privileges'));
    const isExportAfd = privileges?.isExportAfd;
    this.setState({ premium: isExportAfd });
    console.log('procurando privilegios', isExportAfd);
  }

  componentDidUpdate(prevProps, prevState) {
    const prevPrivileges = JSON.parse(localStorage.getItem('privileges'));
    const currentPrivileges = JSON.parse(localStorage.getItem('privileges'));

    if (
      prevPrivileges !== currentPrivileges &&
      (!prevPrivileges || prevPrivileges.isExportAfd !== currentPrivileges.isExportAfd)
    ) {
      const isExportAfd = currentPrivileges?.isExportAfd;
      this.setState({ premium: isExportAfd });
      console.log('procurando privilegios', isExportAfd);
    }
  }

  render() {
    return (
      <Switch>
        <Route path="/logout" component={Logout} />
        <Route path="/404" component={NotFound} />
        <Route path="/email-confirmation/:code" component={EmailConfirmation} />
        <Route path="/cadastro" component={PremiumPayment} />
        <Route
          path="/bem-vindo"
          render={() => (
            <Layout>
              <Switch>
                <Route path="/central-de-atividades" component={this.state.premium ? TaskSchedules : BI2} />
                {/* <Route path="/central-de-servicos" component={ManageActivities} /> */}
                <Route path="/atualizar-empresa" component={UpdateEmployer} />
                <Route path="/funcionarios/cadastrar" component={CreateEmployee} />
                <Route path="/funcionarios/importar" component={ImportEmployee} />
                <Route path="/funcionarios/:id(\d+)" component={EditEmployee} />
                <Route path="/funcionarios" exact component={Employees} />
                <Route path="/pontos/:id(\d+)" exact component={TimeClocks} />
                <Route
                  path="/pontos/:id(\d+)/cadastrar/:date(\d\d\d\d-\d\d-\d\d)"
                  exact
                  component={CreateTimeClock}
                />
                <Route path="/feriados" exact component={this.state.premium ? Holidays : BI2} />
                <Route path="/locais/:id(\d+)" component={EditLocation} />
                <Route path="/locais/cadastrar" exact component={CreateLocation} />
                <Route path="/locais" exact component={Locations} />
                <Route path="/devices" exact component={Devices} />
                <Route path="/cargos" component={Offices} />
                <Route path="/escalas/cadastrar" component={TourGuideSchedule} />
                <Route path="/escalas" exact component={Schedules} />
                <Route path="/departamentos" component={Departments} />
                <Route path="/set" component={SetList} />
                <Route path="/aplicar-restricoes" component={ApplyRestrictions} />
                <Route path="/relatorio/faltas" component={this.state.premium ? AbsenceReport : BI2} />
                <Route path="/relatorio/foto" component={this.state.premium ? PhotoReport : BI2} />
                <Route path="/relatorio/local" component={this.state.premium ? LocationReport : BI2} />
                <Route path="/relatorio" exact component={this.state.premium ? TimeClockReport : BI2} />
                <Route path="/relatorio/list" exact component={TimeListReport} />
                <Route path="/abonos/cadastrar" component={this.state.premium ? CreateAllowance : BI2} />
                <Route path="/abonos" exact component={this.state.premium ? Allowance : BI2} />
                <Route path="/feriados" component={this.state.premium ? Holidays : BI2} />
                <Route path="/acompanhamento/id(\id+)" component={Calendar} />
                <Route path="/acompanhamento" component={Calendar} />
                <Route path="/Tratamento" component={Accompaniment} />
                <Route path="/colaboradores" component={EmployeeViewModel} />
                <Route path="/banco" component={this.state.premium ? ManageEmployees : BI2} />
                <Route path="/horas/:id(\d+)" component={BankOfHours} />
                <Route path="/gestores" component={Users} />
                <Route path="/demitidos" component={Dismissed} />
                <Route path="/bem-vindo" exact component={TourGuideBI} />
                <Redirect to="/404" />
              </Switch>
            </Layout>
          )}
        />

        <Route
          path="/"
          render={() => (
            <Layout>
              <Switch>
                <Route path="/assinatura" component={NewSubscription} />
                <Route path="/central-de-atividades" component={this.state.premium ? TaskSchedules : BI2} />
                {/* <Route path="/central-de-servicos" component={ManageActivities} /> */}
                <Route path="/atualizar-empresa" component={UpdateEmployer} />
                <Route path="/funcionarios/cadastrar" key="create-employee" exact component={CreateEmployee} />
                <Route path="/funcionarios/importar" component={ImportEmployee} />
                <Route path="/funcionarios/:id(\d+)" key="edit-employee" exact component={CreateEmployee} />
                <Route path="/funcionarios" exact component={Employees} />
                <Route path="/pontos/:id(\d+)" exact component={TimeClocks} />
                <Route
                  path="/pontos/:id(\d+)/cadastrar/:date(\d\d\d\d-\d\d-\d\d)"
                  exact
                  component={CreateTimeClock}
                />
                <Route path="/feriados" exact component={this.state.premium ? Holidays : BI2} />
                <Route path="/locais/:id(\d+)" component={EditLocation} />
                <Route path="/locais/cadastrar" exact component={CreateLocation} />
                <Route path="/locais" exact component={Locations} />
                <Route path="/devices" exact component={Devices} />
                <Route path="/cargos" component={Offices} />
                <Route path="/escalas/cadastrar" component={TourGuideSchedule} />
                <Route path="/escalas" exact component={Schedules} />
                <Route path="/departamentos" component={Departments} />
                <Route path="/set" component={SetList} />
                <Route path="/aplicar-restricoes" component={ApplyRestrictions} />
                <Route path="/relatorio/faltas" component={this.state.premium ? AbsenceReport : BI2} />
                <Route path="/relatorio/foto" component={this.state.premium ? PhotoReport : BI2} />
                <Route path="/relatorio/local" component={this.state.premium ? LocationReport : BI2} />
                <Route path="/relatorio/afd" component={this.state.premium ? ImportAfdReport : BI2} />
                <Route path="/relatorio" exact component={this.state.premium ? TimeClockReport : BI2} />
                <Route path="/relatorio/list" exact component={TimeListReport} />
                <Route path="/abonos/cadastrar" component={this.state.premium ? CreateAllowance : BI2} />
                <Route path="/abonos" exact component={this.state.premium ? Allowance : BI2} />
                <Route path="/feriados" component={this.state.premium ? Holidays : BI2} />
                <Route path="/acompanhamento/:id(\d+)" component={Calendar} />
                <Route path="/acompanhamento" component={Calendar} />
                <Route path="/Tratamento" component={Accompaniment} />
                <Route path="/colaboradores" component={EmployeeViewModel} />
                <Route path="/banco" component={this.state.premium ? ManageEmployees : BI2} />
                <Route path="/horas/:id(\d+)" component={BankOfHours} />
                <Route path="/gestores" component={Users} />
                <Route path="/demitidos" component={Dismissed} />
                <Route path="/cameratermica" component={ThermalCam} />
                <Route path="/" exact component={BI2} />
                <Redirect to="/404" />
              </Switch>
            </Layout>
          )}
        />
      </Switch >
    );
  }
}

export default withRouter(withToken(Dashboard));
